module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "portfolio"
  title: 'Tynemouth Chess Club', // Navigation and Site Title
  titleAlt: 'Tynemouth Chess Club', // Title for JSONLD
  description: 'Tynemouth Chess Club',
  url: 'https://tynemouthchessclub.netlify.com', // Domain of your site. No trailing slash!
  siteUrl: 'https://tynemouthchessclub.netlify.com', // url + pathPrefix
  siteLanguage: 'en', // Language Tag on <html> element
  logo: 'static/logo/logo.png', // Used for SEO
  banner: 'static/logo/logo.png',
  // JSONLD / Manifest
  favicon: 'static/logo/logo.png', // Used for manifest favicon generation
  shortName: 'TCC', // shortname for manifest. MUST be shorter than 12 characters
  author: 'Andrew', // Author for schemaORGJSONLD
  themeColor: '#3e7bf2',
  backgroundColor: '#d3e0ff' //,
  //twitter: '@justinformentin', // Twitter Username
};
